import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 37 37", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.5062 36.4357V0.564627H20.2834V36.4357H16.5062ZM0.459229 20.3888V16.6116H36.3303V20.3888H0.459229Z", fill: "currentColor" }));
export default SvgPlus;
